module.exports = __webpack_public_path__ + "static/assets/b14c8684835871bf2d2a411a9638b7dc.png";